import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';

export const FLAG_MIGRACAO = 'migracaoVista';
const NOVA_URL = 'https://komintegrus.com.br';
const FADE_MS = 300;

// Guardas de módulo: sobrevivem à remontagem do Layout na navegação SPA,
// zeradas em reload completo (o login recarrega a página).
let aberto = false;
let erroImagem = false;

// Renderizado num root React próprio (não usa o ModalManager): o singleton de
// Modais.js corrompe seu estado se um segundo modal abrir enquanto outro está
// exibido, e este é o único modal do app que abre sem interação do usuário.
// zIndex um abaixo do ModalManager (99999999) para modais legítimos empilharem por cima.
function ModalMigracao({ aoFechar }) {
    const [visivel, setVisivel] = useState(false);
    const fechadoRef = useRef(false);

    useEffect(() => {
        const t = setTimeout(() => setVisivel(true), 0);
        return () => clearTimeout(t);
    }, []);

    const fechar = useCallback(
        (marcarVisto) => {
            if (fechadoRef.current) return;
            fechadoRef.current = true;
            if (marcarVisto) localStorage.setItem(FLAG_MIGRACAO, '1');
            setVisivel(false);
            aoFechar();
        },
        [aoFechar]
    );

    // ESC em nível de documento (não há campo focável dentro do modal)
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === 'Escape') fechar(true);
        };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [fechar]);

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 99999998,
                overflow: 'hidden',
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                opacity: visivel ? 1 : 0,
                transition: `all ${FADE_MS / 1000}s linear`,
            }}
        >
            <div className="relative inline-block leading-none">
                <img
                    src={process.env.PUBLIC_URL + '/migracao.png'}
                    alt="O EQSGT migrou para komintegrus.com.br"
                    className="block"
                    style={{ maxWidth: '92vw', maxHeight: '90vh', width: 'auto', height: 'auto' }}
                    onError={() => {
                        erroImagem = true;
                        fechar(false);
                    }}
                />
                {/* Hotspots invisíveis sobre o X e o botão já desenhados na arte */}
                <button
                    type="button"
                    aria-label="Fechar aviso"
                    onClick={() => fechar(true)}
                    className="absolute cursor-pointer"
                    style={{ left: '91.5%', top: 0, width: '7%', height: '10.5%', background: 'transparent', border: 'none', padding: 0 }}
                />
                <button
                    type="button"
                    aria-label="Acessar nova versão"
                    onClick={() => {
                        localStorage.setItem(FLAG_MIGRACAO, '1');
                        window.location.href = NOVA_URL;
                    }}
                    className="absolute cursor-pointer"
                    style={{ left: '64.5%', top: '87%', width: '31%', height: '10.5%', background: 'transparent', border: 'none', padding: 0 }}
                />
            </div>
        </div>
    );
}

export function showModalMigracao() {
    if (aberto || erroImagem) return;
    if (!localStorage.getItem('token')) return;
    if (localStorage.getItem(FLAG_MIGRACAO)) return;
    aberto = true;

    const node = document.createElement('div');
    document.body.appendChild(node);
    const root = createRoot(node);
    const aoFechar = () => {
        setTimeout(() => {
            root.unmount();
            node.remove();
            aberto = false;
        }, FADE_MS);
    };
    root.render(<ModalMigracao aoFechar={aoFechar} />);
}
